import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CommonTable from '../../common/commonTable/CommonTable';
import PaginationComponent from '../../common/pagination/Pagination';
import { getOnboardingRequests } from '../../../api/admin/adminApi';
import { formatDate } from '../../../utils/helper';
import FilterHeader from '../FilterHeader';
import { Container } from 'react-bootstrap';
import Context from '../../../context/Context';

const OnboardingRequests = () => {
    const [requests, setRequests] = useState([]);
    const columns = [
        { header: 'Organization Name', accessor: 'company_name' },
        { header: 'Employee Name', accessor: (row) => (row?.hierarchy_data?.company_head?.first_name + " " + row?.hierarchy_data?.company_head?.last_name + " " + '(CEO)') },
        { header: 'Email', accessor: (row) => row?.hierarchy_data?.company_head?.email },
        { header: 'Invite Received On', accessor: (row) => formatDate(row?.created_at) },
        {
            header: 'Status',
            accessor: (row) => {
                let bg = "bg-gray-300 text-gray-800";

                if (row?.status?.toLowerCase() === "pending") {
                    bg = "bg-yellow-200 text-yellow-800";
                } else if (row?.status?.toLowerCase() === "approved") {
                    bg = "bg-green-200 text-green-800";
                } else if (row?.status?.toLowerCase() === "rejected") {
                    bg = "bg-red-200 text-red-800";
                }
                return (
                    <span className={`px-3 py-2 rounded-full text-sm font-semibold ${bg}`}>
                        {row?.status}
                    </span>
                );
            }
        }
    ];
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [hasFetched, setHasFetched] = useState(false);
    const { setPageTitle } = useContext(Context);

    const itemsPerPage = 10;
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const handlePageChange = (page) => {

        if (page > 1) {
            searchParams.set('p', page);
        } else {
            searchParams.delete('p');
        }
        navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
        getOnboardingRequests({ page: page }, (response) => {
            if (response?.status === true) {
                setTotalCount(response?.count);
                setRequests(response?.data);
            }
        });
        setCurrentPage(page);
    };

    const handleRowClick = (row) => {
        navigate(`/admin/onboarding-requests/${row?.id}`)
    }

    const fetchOnboardingRequests = () => {
        setLoading(true);
        const page = searchParams.get('p');
        const payload = page ? { page: page } : {};
        setCurrentPage(parseInt(page) || 1);

        getOnboardingRequests(payload, (response) => {
            if (response?.status === true) {
                setTotalCount(response?.count);
                setRequests(response?.data);
            }
            setLoading(false);
            setHasFetched(true);
        });
    };

    useEffect(() => {
        setPageTitle('Onboarding Requests');
        fetchOnboardingRequests();
    }, [setPageTitle]);

    return (
        <section className="p-4">
            {/* <FilterHeader title="Onboarding Requests" isButton={false} /> */}
            <div>
                <CommonTable
                    columns={columns}
                    data={requests}
                    loading={loading}
                    hasFetched={hasFetched}
                    isExport={false}
                    isRowClick={true}
                    onRowClick={handleRowClick}
                />
                {totalCount > 10 && <PaginationComponent
                    currentPage={currentPage}
                    totalCount={totalCount}
                    itemsPerPage={itemsPerPage}
                    onPageChange={handlePageChange}
                />}
            </div>
        </section>
    )
}

export default OnboardingRequests;